import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

export const useCars = (userId) => {
  const [cars, setCars] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchCars = useCallback(async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const response = await api.get('/cars', { params: { userId } });
      const carsData = response?.ok && response.data?.data ? response.data.data : [];
      setCars(carsData);
      return carsData;
    } catch {
      // Keep previous state on error to avoid flashing empty while refetching
      return [];
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchCars();
  }, [fetchCars]);

  return { data: cars, loading, refetch: fetchCars };
};
